/**
 * Applications mobiles Golden Mali — liens stores (publication à venir)
 */
export const MOBILE_APPS_LIVE = false;

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.goldenmali.goldflowmanager';

export const APP_STORE_URL =
  'https://apps.apple.com/app/golden-mali/id0000000000';

export const STORE_QR = {
  android: '/api/public/store-qrcode?store=android',
  ios: '/api/public/store-qrcode?store=ios',
};
